import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a12a28e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a12a28e')) {
      api.createRecord('2a12a28e', component.options)
    } else {
      api.reload('2a12a28e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a12a28e", function () {
      api.rerender('2a12a28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/journalManage/index.vue"
export default component.exports